define('plugin/multiple-booking/view/MultipleBookingListView',['require','__original__/MultipleBookingListView','pwa/plugin/multiple-booking/view/MultipleBookingEmptyView'],function (require) {

    var ParentMultipleBookingListView = require('__original__/MultipleBookingListView');
    var MultipleBookingEmptyView = require("pwa/plugin/multiple-booking/view/MultipleBookingEmptyView");

    /**
     * Multiple booking list view
     *
     * @class MultipleBookingListView
     */
    return ParentMultipleBookingListView.extend({

        // emptyView: MultipleBookingEmptyView,

        serializeData: function () {
            var result = ParentMultipleBookingListView.prototype.serializeData.apply(this);

            var total = 0;
            var currency = null;

            this.getOption('collection').map(function (bookingModel) {
                var prices = bookingModel.getPrices();
                if (prices) {
                    var totals = prices.totals;
                    if (totals) {
                        total += totals.total;
                        currency = totals.currency;
                    }
                }
            });

            result.total = total;
            result.currency = currency;

            return result;
        }
    });

});
